import { render, staticRenderFns } from "./EngagementsList.vue?vue&type=template&id=4ad53a45&"
import script from "./EngagementsList.vue?vue&type=script&lang=ts&"
export * from "./EngagementsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports